export const MODES = [
  {
    label: 'All',
    value: 'all'
  },
  {
    label: 'Citation Statements',
    value: 'citations'
  },
  {
    label: 'Papers',
    value: 'papers'
  },
  {
    label: 'Ask a Question',
    value: 'question-answering'
  }
]

const sortLabel = label => `Sort by: ${label}`

export const SORT_OPTIONS = [
  {
    value: {},
    label: sortLabel('Relevance')
  },
  {
    label: sortLabel('Date published (recent)'),
    value: { key: 'date', order: 'desc' }
  },
  {
    label: sortLabel('Date published (oldest)'),
    value: { key: 'date', order: 'asc' }
  },
  {
    label: sortLabel('Most cited'),
    value: { key: 'total_cited', order: 'desc' }
  },
  {
    label: sortLabel('Least cited'),
    value: { key: 'total_cited', order: 'asc' }
  },
  {
    label: sortLabel('Most supported'),
    value: { key: 'total_supported', order: 'desc' }
  },
  {
    label: sortLabel('Least supported'),
    value: { key: 'total_supported', order: 'asc' }
  },
  {
    label: sortLabel('Most contrasted'),
    value: { key: 'total_contrasted', order: 'desc' }
  },
  {
    label: sortLabel('Least contrasted'),
    value: { key: 'total_contrasted', order: 'asc' }
  }
]

export const RETRACTION_STATUS_TO_FILTER = {
  Retracted: 'hasRetraction',
  'Has expression of concern': 'hasConcern',
  'Has correction': 'hasCorrection',
  'Has erratum': 'hasErratum',
  Withdrawn: 'hasWithdrawn'
}

export const PAPER_TYPE_FILTER = {
  Book: 'bookFilter',
  Article: 'articleFilter',
  Preprint: 'preprintFilter',
  'Other Source Types': 'otherPaperTypeFilter'
}

export const CITATION_TYPE_FILTER = {
  'Has Cites': 'hasCites'
}
